import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const MobileNavbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const menuItems = [
        { name: "My home", path: "/" },
        { name: "Welcome to my still images", path: "/still-image-gallery" },
        { name: "My movable pieces", path: "/movable-pieces" },
        { name: "The soul of my work", path: "/soul-of-my-work" },
        { name: "A sketch of my profile", path: "/sketch-of-my-profile" },
        { name: "Find myself", path: "/find-myself" },
    ];

    return (
        <div className="lg:hidden">
            <div className="flex justify-between items-center py-4 px-6 bg-white shadow-md">
                <span className="font-bold text-gray-500 text-md">Paramita Chakraborty</span>
                <button onClick={() => setIsOpen(!isOpen)} className="focus:outline-none">
                    {isOpen ? <X className="text-gray-600" size={24} /> : <Menu className="text-gray-600" size={24} />}
                </button>
            </div>

            <div
    className={`fixed top-4 right-4 z-50 bg-white shadow-xl rounded-lg transform transition-transform duration-300 w-72 ${
        isOpen ? "scale-100 opacity-100" : "scale-95 opacity-0 pointer-events-none"
    }`}
>
                <div className="flex justify-between items-center pb-2 px-2">
                    <span className="font-bold text-gray-500 text-md"> </span>
                    <button onClick={() => setIsOpen(false)} className="focus:outline-none">
                        <X className="text-gray-600" size={24} />
                    </button>
                </div>

                <nav className="px-4 py-10 space-y-3 bg-gray-200 m-4 mt-0 font-semibold">
                    {menuItems.map((item) => (
                        <p
                            key={item.name}
                            onClick={() => {
                                navigate(item.path);
                                setIsOpen(false);
                            }}
                            className={`text-sm cursor-pointer transition-colors duration-300 font-semibold ${location.pathname === item.path ? "text-blue-600 font-medium" : "text-gray-600"
                                } hover:text-blue-600`}
                        >
                            {item.name}
                        </p>
                    ))}
                </nav>
                
                

            </div>
        </div>
    );
};

export default MobileNavbar;
